import { css } from '@emotion/react'
export const cubitFormStyles = {
    field: css`
        max-width: 100%;
        width: 100%;
        display: block;
        margin-bottom: 16px;
    `,
}
